import React from "react"
import * as styles from "./ProductFileLink.module.scss"

export type ProductFileLinkProps = {
  thumbnail: string
  link: string
  title: string
  children: React.ReactNode
}

const ProductFileLink = (props: ProductFileLinkProps) => {
  // console.log("Rendering ProductFileLink", props)
  return (
    <a href={props.link} download title={props.title}>
      <div className={styles.container}>
        <img className={styles.thumb} src={props.thumbnail} alt="" />

        <div className={styles.text}>
          <p className={styles.title}>{props.title}</p>
          <div className={styles.details}>{props.children}</div>
        </div>
      </div>
    </a>
  )
}

export default ProductFileLink
